"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const roomImg = (0, react_redux_1.useSelector)((state) => state.roomData.img_url);
    const startDate = (0, react_redux_1.useSelector)((state) => state.roomData.start_date);
    const isNotStarted = (0, moment_1.default)(startDate).isAfter();
    const endDate = (0, react_redux_1.useSelector)((state) => state.roomData.end_date);
    const momentEndDate = (0, moment_1.default)(endDate);
    const isEnded = momentEndDate.isSameOrBefore();
    const isEndToday = momentEndDate.isSame((0, moment_1.default)(), 'day');
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const subTextRequired = !(isNotStarted || isEnded || isEndToday);
    const dDay = Math.ceil(momentEndDate.diff((0, moment_1.default)(), 'days', true));
    const daysLeftText = () => {
        if (isNotStarted)
            return t('오픈 예정');
        else if (isEnded)
            return t('마감');
        else if (isEndToday)
            return t('오늘 마감');
        else
            return `D-${dDay}`;
    };
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const handleLeaderSettingClick = () => !isPreview && (window.location.href = `/room/room_manager/?roomId=${roomId}`);
    const leaderId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const isManager = isPreview || leaderId === whoAmI.id || whoAmI.is_admin;
    const title = (0, react_redux_1.useSelector)((state) => state.roomData.title);
    const isFeeFree = (0, react_redux_1.useSelector)((state) => state.roomData.fee_free);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(MainInfoWrapper, { children: [roomId && ((0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(roomImg) ||
                    `${process.env.CDN_URL}/assets/images/default-${(0, functions_1.fixedRemainder)(roomId, 12)}.webp`, css: { aspectRatio: maxWidth768 ? '3 / 2' : '20 / 9', width: '100%', objectFit: 'cover' } })), endDate && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "float_right_circle", id: "d_day" }, { children: [subTextRequired && (0, jsx_runtime_1.jsx)("div", { children: t('판매종료') }), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { fontSize: '14px', fontWeight: 600 } }, { children: daysLeftText() }))] }))), isManager && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "float_right_circle", id: "manager", onClick: handleLeaderSettingClick }, { children: [(0, jsx_runtime_1.jsx)("div", { children: t('수정') }), (0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px' } })] }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "title" }, { children: [isDemandSurvey ? ((0, jsx_runtime_1.jsxs)("span", Object.assign({ css: { marginRight: '6px' } }, { children: ["[", t('수요조사'), "]"] }))) : (!isFeeFree && ((0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/images/payform_gold_card.webp`, css: { width: '24px', height: '15px', margin: '0 6px -2px 0' } }))), title] }))] }));
}
exports.default = default_1;
const MainInfoWrapper = styled_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: white;
  .float_right_circle {
    position: absolute;
    right: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    text-align: center;
    div:first-of-type {
      padding: 2px 0;
      font-size: 13px;
    }
  }
  #d_day {
    top: 16px;
    border: 1px solid #000;
    background: rgba(0, 0, 0, 0.8);
    color: white;
  }
  #manager {
    top: 86px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.8);
    color: rgba(0, 0, 0, 0.8);
    cursor: pointer;
  }
  #title {
    padding: 14px 16px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.8);
    word-break: break-all;
  }
`;
